<template>
    <div v-loading="loading">
        <div class="search-ctn" style="padding-top: 0; padding-left: 10px; padding-right: 10px">
            <div class="search-name">商品名称：{{ goodsData.GoodsName }}</div>
            <div class="search-name">汽配编码：{{ goodsData.APCode }}</div>
            <div class="search-name">适用车型：{{ goodsData.AutoSerise }}</div>
            <div class="search-name">商品总数：{{ goodsData.Count }}</div>
        </div>
        <div class="table-ctn">
            <el-table :header-cell-style="{ background: '#F2F6FC' }" :data="tableData" border style="width: 100%; margin-bottom: 10px">
                <el-table-column width="200px" prop="LabelCode" label="标签码" show-overflow-tooltip></el-table-column>
                <el-table-column width="80px" prop="PackingSpec" label="商品数" show-overflow-tooltip></el-table-column>
                <el-table-column  prop="CreateTime" label="创建时间" show-overflow-tooltip></el-table-column>
            </el-table>
        </div>
        <div class="dialog-pagination-ctn">
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="searchData.page"
                :page-sizes="[10, 20, 30, 40, 50, 200]"
                :page-size="searchData.limit"
                layout="total, sizes, prev, pager, next, jumper"
                :total="tableDataLength"
            ></el-pagination>
        </div>
    </div>
</template>
<script>
export default {
    name: '',
    props: ['goodsData'],
    components: {},
    data() {
        return {
            loading: false,
            searchData: {
                BoxId: '',
                GoodsId: '',
                page: 1,
                limit: 10
            },
            tableData: [],
            tableDataLength: 0
        };
    },
    mounted() {
        this.searchData.GoodsId = this.goodsData.GoodsId;
        this.searchData.BoxId = this.goodsData.BoxId;
        this.getTableData();
    },
    methods: {
        getTableData() {
            let that = this;
            that.loading = true;
            that.$util
                .axiosGet({
                    url: '/api/EntpBoxes/GetBoxLabels',
                    data: that.searchData,
                    hideLoading:true
                })
                .then(res => {
                    that.tableData = res.data;
                    that.tableDataLength = res.count;
                    that.loading = false;
                })
                .catch(() => {
                    that.loading = false;
                });
        },
        handleSizeChange(val) {
            this.searchData.page = 1;
            this.searchData.limit = val;
            this.getTableData();
        },
        handleCurrentChange(val) {
            this.searchData.page = val;
            this.getTableData();
        }
    }
};
</script>
<style lang="less" scoped>
.search-ctn {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    .search-ctn-left {
        display: flex;
    }
    .search-ctn-right {
        display: flex;
        align-items: center;
    }
}
</style>
